import React from "react";
import { CheckCircle2, Clock, Hammer } from "lucide-react";

const STATUS_MAP = {
  paid: { label: "Paid", cls: "bg-olive/15 text-olive border-olive/30", Icon: CheckCircle2 },
  in_build: { label: "In Build", cls: "bg-clay/15 text-clay border-clay/40", Icon: Hammer },
  new_intake: { label: "New", cls: "bg-clay/10 text-clay border-clay/30", Icon: Clock },
  needs_review: { label: "Needs review", cls: "bg-rust/10 text-rust border-rust/30", Icon: Clock },
  blocked_missing_info: { label: "Blocked", cls: "bg-rust/10 text-rust border-rust/30", Icon: Clock },
  incomplete: { label: "Incomplete", cls: "bg-sand-300 text-ink-muted border-sand-400", Icon: Clock },
};

/** Status pill for an intake/submission row. */
export const Badge = ({ status }) => {
  const m = STATUS_MAP[status] || {
    label: status || "—",
    cls: "bg-sand-300 text-ink-muted border-sand-400",
    Icon: Clock,
  };
  const I = m.Icon;
  return (
    <span
      data-testid={`intake-badge-${status || "unknown"}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 font-mono text-[10px] uppercase tracking-[0.16em] ${m.cls}`}
    >
      <I size={11} />
      {m.label}
    </span>
  );
};

/** Single stat card used in the admin dashboard header. */
export const Stat = ({ label, value, accent, testid }) => {
  const accentCls =
    accent === "olive" ? "text-olive" : accent === "clay" ? "text-clay" : "text-ink";
  return (
    <div
      data-testid={testid}
      className="rounded-2xl border border-sand-300 bg-sand-50 p-4 sm:p-5"
    >
      <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-ink-muted">
        {label}
      </p>
      <p className={`mt-2 font-display text-2xl sm:text-3xl font-semibold tracking-tight ${accentCls}`}>
        {value}
      </p>
    </div>
  );
};
